<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><a id="page_6"></a><span class="bold">Photographs</span></h2>
<p class="noindent">Having studied the air wars of 1914-19 and 1939-1945 for over fifty years, and having been a full-time military aviation historian for the last twenty-five, collecting images of the men and machines of both conflicts has not been difficult. Fortunately I was able to meet and correspond with a number of Great War veterans and almost all had their own collections of pictures, either taken by them or by friends who gladly had copies made for them and other men in their squadrons. I have been fortunate too to have been in contact with many brother Great War enthusiasts and, over the years, we have tended to copy and swap between us some of the more interesting photographs. Sadly a number of them have long since left the ground for the last time. However, I wish to thank those who have been pleased to help with photographs over the years: Greg van Wyngarden, Andy Thomas, Jon Guttman, Trevor Henshaw, Phil Jarrett, Stuart Leslie, Tony Mellor-Ellis, Walter Pieters, Andy Saunders, the late Mike O’Connor, Chaz Bowyer, Frank Cheesman, Ed Ferko, Neil O’Connor, Frank ‘Bill’ Bailey, Les Rogers and Hal Giblin.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Photographs.vue?115589fc